module.exports = __webpack_public_path__ + "img/de100a300vidas.62c92ff4.png";